import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
  CountryField,
  SearchFormButton,
  //   PassportTypeField,
  //   DateField,
  TransitAirportsField,
} from '../../../components';
import { Formik } from 'formik';
import { TravelRequirementsReqSchema } from '../TravelRequirementsReqSchema';
import { stringify } from 'query-string';

RequirementsSearchForm.propTypes = {};

function RequirementsSearchForm({ formData, countries, onSearch }) {
  const { t } = useTranslation();

  const searchHandler = async (values) => {
    const formData = { ...values };
    if (formData && formData.transitAirports) {
      formData.transitAirports = formData.transitAirports
        .map((airport) => airport.code)
        .join();
    }

    const newPath = stringify(formData);
    window.history.replaceState({ path: newPath }, '', '?' + newPath);
    await onSearch(formData);
    return true;
  };

  const sasOperatedCountries = [
    'AL',
    'AM',
    'AT',
    'BA',
    'BE',
    'BG',
    'CH',
    'CN',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'EG',
    'ES',
    'FI',
    'FO',
    'FR',
    'GB',
    'GL',
    'GR',
    'HK',
    'HR',
    'HU',
    'IE',
    'IL',
    'IS',
    'IT',
    'JO',
    'JP',
    'LB',
    'LT',
    'LU',
    'LV',
    'MA',
    'ME',
    'MT',
    'NL',
    'NO',
    'PL',
    'PT',
    'RO',
    'RS',
    'RU',
    'SE',
    'SK',
    'TH',
    'TN',
    'TR',
    'UA',
    'US',
    'CA',
    'SG',
  ];
  const whitelistedCountries = countries.filter(
    (country) => sasOperatedCountries.indexOf(country.code) > -1
  );

  return (
    <Box>
      <Typography variant="h6" color="primary">
        {t('formHeading')}
      </Typography>
      <Box marginY={3}>
        <Formik
          initialValues={formData}
          validateOnBlur={false}
          validateOnChange={false}
          validationSchema={TravelRequirementsReqSchema}
          onSubmit={searchHandler}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <CountryField
                id="departureAirportCode"
                name="departureAirportCode"
                label={t('origin')}
                data={whitelistedCountries}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <CountryField
                id="destinationCountryCode"
                name="destinationCountryCode"
                label={t('destination')}
                data={whitelistedCountries}
                required
              />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={4}>
              <DateField
                id="arrivalDate"
                name="arrivalDate"
                label={t('arrivalDate')}
                required
              />
            </Grid> */}

            <Grid item xs={12} sm={6} md={6}>
              <CountryField
                id="nationality"
                name="nationality"
                label={t('nationality')}
                data={countries}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <CountryField
                id="residentCountryCode"
                name="residentCountryCode"
                label={t('residenceCountry')}
                data={countries}
                required
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TransitAirportsField
                id="transitAirports"
                name="transitAirports"
                label={t('transitAirports')}
                noOptionsText={t('noAirports')}
                data={countries}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={4}>
              <PassportTypeField
                id="documentType"
                name="documentType"
                label={t('documentType')}
                required
              />
            </Grid> */}
            <Grid item xs={12} sm={12} md={4}>
              <SearchFormButton>{t('checkRequirementsBtn')}</SearchFormButton>
            </Grid>
          </Grid>
        </Formik>
      </Box>
    </Box>
  );
}

export default RequirementsSearchForm;
